import { get } from 'react-hook-form';
import { supabase,supabaseAdmin } from '../lib/supabase';
import { createClient } from '@supabase/supabase-js'
import {data} from "autoprefixer";
 
// Authentication Services
export const authService = {
   async signUp(email, password, userData = {}) {
  try {  
    const { data, error } = await supabase.auth.signUp({
      email,
      password,
      options: {
        // email_confirm se met dans les options, pas au niveau racine
        data: {
          full_name: userData?.fullName || '',
          role: userData?.role || 'inspector',
          phone: userData?.phone || '',
          //tenant_id: userData?.tenant_id || null,
          //avatar_url: userData?.avatar_url || ''
          // Supprimé: address, company, department, position (n'existent pas dans user_profiles)
        }
      }
    })

    // Si la création est réussie, créer le profil dans user_profiles
    if (data && data.user && !error) {
     const { data: profileData, error: profileError } = await supabase
        .from('user_profiles')
        .update({
          email: email,
          full_name: userData?.fullName || '',
          phone: userData?.phone || '',
          role: userData?.role || 'inspector',
          tenant_id: userData?.tenant_id || null,
          avatar_url: userData?.avatar_url || '',
          is_active: true,
          updated_at: new Date().toISOString(),
          //client_id: userData?.client_id || null
        })
        .eq('id', data.user.id) // Important: mettre à jour le bon profil
        .select()
        .single()

     

      return { 
        data: { 
          user: data.user, 
          profile: profileData 
        }, 
        error: null 
      }
    }

    return { data, error }
  } catch (error) {
    console.error('SignUp error:', error)
    return { error: { message: 'Erreur réseau. Veuillez réessayer.' } }
  }
},
  async CreateUser(email, password, userData = {}) {
  try {  
    const { data, error } = await supabaseAdmin.auth.admin.createUser({
      email,
      password,
      email_confirm: true,
//  app_metadata: {
//         role: userData?.role || 'inspector' // Stocké dans app_metadata
//       },
       user_metadata: {
        full_name: userData?.fullName || '',
        phone: userData?.phone || '',
                role: userData?.role || 'inspector' // Stocké dans app_metadata

      }
      // options: {
      //   // email_confirm se met dans les options, pas au niveau racine
      //   // data: {
      //   //   full_name: userData?.fullName || '',
      //   //   role: userData?.role || 'inspector',
      //   //   phone: userData?.phone || '',
      //   //   //tenant_id: userData?.tenant_id || null,
      //   //   //avatar_url: userData?.avatar_url || ''
      //   //   // Supprimé: address, company, department, position (n'existent pas dans user_profiles)
      //   // }
      // }
    })

    // Si la création est réussie, créer le profil dans user_profiles
    if (data && data.user && !error) {
     const { data: profileData, error: profileError } = await supabase
        .from('user_profiles')
        .insert({
          email: email,
          full_name: userData?.fullName || '',
          phone: userData?.phone || '',
          role: userData?.role || 'inspector',
         // tenant_id: userData?.tenant_id || null,
          avatar_url: userData?.avatar_url || '',
          is_active: true,
          created_at: new Date().toISOString(),
          id: data.user.id
          //client_id: userData?.client_id || null
        })
        //.eq('id', data.user.id) // Important: mettre à jour le bon profil
        .select()
        .single()

     

      return { 
        data: { 
          user: data.user, 
          profile: profileData 
        }, 
        error: null 
      }
    }

    return { data, error }
  } catch (error) {
    console.error('SignUp error:', error)
    return { error: { message: 'Erreur réseau. Veuillez réessayer.' } }
  }
},

  /**
   * Change le mot de passe d'un utilisateur (admin).
   */
  async updateUserPassword(userId, password) {
    try {
      if (!userId) {
        return { data: null, error: { message: 'Identifiant utilisateur manquant' } };
      }
      if (!password || String(password).length < 6) {
        return { data: null, error: { message: 'Le mot de passe doit contenir au moins 6 caractères' } };
      }

      const { data, error } = await supabaseAdmin.auth.admin.updateUserById(userId, {
        password,
      });

      if (error) {
        console.error('updateUserPassword error:', error);
        return { data: null, error };
      }

      return { data, error: null };
    } catch (error) {
      console.error('updateUserPassword exception:', error);
      return { data: null, error: { message: 'Erreur réseau. Veuillez réessayer.' } };
    }
  },

  async signIn(email, password) {
    try {
      const { data, error } = await supabase?.auth?.signInWithPassword({ email, password })
      return { data, error }
    } catch (error) {
      return { error: { message: 'Erreur réseau. Veuillez réessayer.' } }
    }
  },

  async signOut() {
    try {
      const { error } = await supabase?.auth?.signOut()
      return { error }
    } catch (error) {
      return { error: { message: 'Erreur réseau. Veuillez réessayer.' } }
    }
  },

  async getCurrentUser() {
    try {
      console.log(supabase?.auth?.getUser());
      const { data: { user } } = await supabase?.auth?.getUser()

      return { user, error: null }
    } catch (error) {
      return { user: null, error }
    }
  }
}

// User Profile Services
export const userService = {
  async getUserProfile(userId) {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.select(`*`)
        ?.eq('id', userId)
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },

  async updateUserProfile(userId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.update(updates)
        ?.eq('id', userId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },

  async getAllUsers() {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.select(`*`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },

async getUsersByRole(role) {
    try {
      const { data, error } = await supabase
        ?.from('user_profiles')
        ?.select(`
          *,
       
        `)
        ?.eq('role', role)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },
  
}
export const equipmentService = {
  async getEquipments() {
    try {
      const { data, error } = await supabase
        ?.from('equipment')
        ?.select(`*,service(*),problem(*,service(*))`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    } 
  },
  async getEquipmentById(equipmentId) {
    try {
      const { data, error } = await supabase
        ?.from('equipment')
        ?.select(`*,service(*),problem(*,service(*))`)
        ?.eq('id', equipmentId)
        ?.single()
      return { data: data || null, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async deleteEquipment(equipmentId) {
    try {
      const { data, error } = await supabase
        ?.from('equipment')
        ?.delete()
        ?.eq('id', equipmentId)
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async updateEquipment(equipmentId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('equipment')
        ?.update(updates)
        ?.eq('id', equipmentId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async addEquipment(newEquipment) {  
    try { 
      const { data, error } = await supabase
        ?.from('equipment')
        ?.insert(newEquipment)
        ?.select()
        ?.single()
      return { data, error }
    } 
    catch (error) {   
      return { data: null, error }
    }
  },
}
export const problemService = {
  async getProblems() { 
    try { 
      const { data, error } = await supabase
        ?.from('problem')
        ?.select(`*,service(*)`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }   
  },
  async getProblemById(problemId) {
    try { 
      const { data, error } = await supabase
        ?.from('problem')
        ?.select(`*,service(*)`)
        ?.eq('id', problemId)
        ?.single()
      return { data: data || null, error }
    } catch (error) {
      return { data: null, error }
    } 
  },
  async deleteProblem(problemId) {
    try { 
      const { data, error } = await supabase
        ?.from('problem')
        ?.delete()
        ?.eq('id', problemId)
      return { data, error }
    } catch (error) {
      return { data: null, error }
    } 
  },
  async updateProblem(problemId, updates) {
    try { 
      const { data, error } = await supabase
        ?.from('problem') 
        ?.update(updates)
        ?.eq('id', problemId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async addProblem(newProblem) {  
    try {
      const { data, error } = await supabase
        ?.from('problem')
        ?.insert(newProblem)
        ?.select()  
        ?.single()
      return { data, error }
    }
    catch (error) {   
      return { data: null, error }
    }
  },
}
export const serviceService = {
  async getServices() { 
    try { 
      const { data, error } = await supabase
        ?.from('service') 
        ?.select(`*,equipment(*,category(*))`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },
  async getServiceById(serviceId) {
    try { 
      const { data, error } = await supabase
        ?.from('service') 
        ?.select(`*,equipment(*,category(*))`)
        ?.eq('id', serviceId)
        ?.single()
      return { data: data || null, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async deleteService(serviceId) {
    try {
      const { data, error } = await supabase
        ?.from('service') 
        ?.delete()
        ?.eq('id', serviceId)
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async updateService(serviceId, updates) { 
    try {
      const { data, error } = await supabase
        ?.from('service') 
        ?.update(updates) 
        ?.eq('id', serviceId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    } 
  },
  async addService(newService) {  
    try { 
      const { data, error } = await supabase  
        ?.from('service') 
        ?.insert(newService) 
        ?.select()  
        ?.single()
      return { data, error }
    }
    catch (error) {   
      return { data: null, error }
    }
  },
} 
export const serviceMaterialService = {
  async getAll() {
    try {
      const { data, error } = await supabase
        ?.from('service_matriel')
        ?.select('*')
        ?.order('created_at', { ascending: true })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },
  async getByService(serviceId) {
    try {
      const { data, error } = await supabase
        ?.from('service_matriel')
        ?.select('*')
        ?.eq('service_id', serviceId)
        ?.order('created_at', { ascending: true })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },
  async create(material) {
    try {
      const now = new Date().toISOString()
      const { data, error } = await supabase
        ?.from('service_matriel')
        ?.insert({ ...material, created_at: now, updated_at: now })
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async update(materialId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('service_matriel')
        ?.update({ ...updates, updated_at: new Date().toISOString() })
        ?.eq('id', materialId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async setDefault(serviceId, materialId) {
    try {
      const now = new Date().toISOString()
      const { error: resetError } = await supabase
        ?.from('service_matriel')
        ?.update({ is_default: false, updated_at: now })
        ?.eq('service_id', serviceId)
        ?.neq('id', materialId)
        ?.eq('is_default', true)
      if (resetError) return { data: null, error: resetError }
      const { data, error } = await supabase
        ?.from('service_matriel')
        ?.update({ is_default: true, updated_at: now })
        ?.eq('id', materialId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async remove(materialId) {
    try {
      const { error } = await supabase
        ?.from('service_matriel')
        ?.delete()
        ?.eq('id', materialId)
      return { error }
    } catch (error) {
      return { error }
    }
  },
}
export const emergencyPercentageService = {
  async updateEmergencyPercentage(updates) { 
    try {
      const { data, error } = await supabase
        ?.from('emergency_percentage') 
        ?.update(updates)
        ?.eq('id', 1)
        ?.select()
        ?.single()
      return { data, error }
    }
    catch (error) {
      return { data: null, error }
    }
  },
  async getById(id) {
    try {
      const { data, error } = await supabase
        ?.from('emergency_percentage')
        ?.select(`*`)
        ?.eq('id', id)
        ?.single()
      return { data: data || null, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async getAll() {
    try {
      const { data, error } = await supabase
        ?.from('emergency_percentage')
        ?.select(`*`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    } 
  },
}
export const checklistService = {
  async getAllChecklists() { 
    try {
      const { data, error } = await supabase
        ?.from('checklists')
        ?.select(`*`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },
  async createChecklist (newChecklist) {
    try {
      const { data, error } = await supabase
        ?.from('checklists')
        ?.insert(newChecklist)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async getChecklistById(checklistId) {
    try {
      const { data, error } = await supabase
        ?.from('checklists')
        ?.select(`*`)
        ?.eq('id', checklistId)
        ?.single()
      return { data: data || null, error }
    } catch (error) { 
      return { data: null, error }
    }
  },
}
export const appointmentService = {
  async getAppointments() { 
    try { 
      const { data, error } = await supabase
        ?.from('appointments') 
        ?.select(`*,Service(*,problem(*,equipment(*,category(*)))),technician:user_profiles!appointments_technician_fkey(id,full_name,email,phone,role),appointment_quote(id,status,reference,refusal_reason,refusal_comment,refused_at,total_ttc,price,created_at,updated_at)`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    }
    catch (error) {
      return { data: [], error }
    }
  },
  async getAppointmentsBytechnician_id(userId) {
    try { 
      const { data, error } = await supabase
        ?.from('appointments') 
        ?.select(`*`)
        ?.eq('technician', userId)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    }
  },
  async getAppointmentById(appointmentId) {
    try { 
      const { data, error } = await supabase    
        ?.from('appointments ') 
        ?.select(`*,Service(*)`)
        ?.eq('id', appointmentId)
        ?.single()
      return { data: data || null, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async updateAppointmentStatus(appointmentId, status) { 
    try {
      const { data, error } = await supabase
        ?.from('appointments') 
        ?.update({ status }) 
        ?.eq('id', appointmentId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async deleteAppointment(appointmentId) {
    try {
      const { data, error } = await supabase    
        ?.from('appointments') 
        ?.delete()
        ?.eq('id', appointmentId)
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async updateAppointment(appointmentId, updates) { 
    try {
      const { data, error } = await supabase
        ?.from('appointments') 
        ?.update(updates) 
        ?.eq('id', appointmentId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    } 
  },
}
export const consumableService = {
 
  async getAllConsumables() {
    const { data, error } = await supabase
      ?.from('consumables')
      ?.select('*')
      ?.order('name');
    
    if (error) throw error;
    return { data, error: null };
  },

 
  async getConsumablesWithAlerts() {
    const { data, error } = await supabase
      ?.from('restock_alerts')
      ?.select('*, consumables(*)')
      ?.eq('is_resolved', false)
      ?.order('created_at', { ascending: false });
    
    if (error) throw error;
    return { data, error: null };
  },


  async getSuppliersWithConsumablesCount() {
    const { data, error } = await supabase
      ?.from('suppliers')
      ?.select('*, consumables(count)')
      ?.order('name');
    
    if (error) throw error;
    return { data, error: null };
  },

 
  async getConsumablesDashboardData() {
    try {
      const [consumablesResult, alertsResult, suppliersResult] = await Promise.all([
        supabase?.from('consumables')?.select('*')?.order('name'),
        supabase?.from('restock_alerts')?.select('*, consumables(*)')?.eq('is_resolved', false)?.order('created_at', { ascending: false }),
        supabase?.from('suppliers')?.select('*, consumables(count)')?.order('name')
      ]);

      return {
        consumables: consumablesResult?.data || [],
        alerts: alertsResult?.data || [],
        suppliers: suppliersResult?.data || [],
        errors: {
          consumables: consumablesResult?.error,
          alerts: alertsResult?.error,
          suppliers: suppliersResult?.error
        }
      };
    } catch (error) {
      console.error('Erreur lors du chargement des données des consommables:', error);
      throw error;
    }
  }
};
export const categoryService = {
  async getCategories() {
    try { 
      const { data, error } = await supabase
        ?.from('category')
        ?.select(`*,equipment(*,service(*),problem(*,service(*)))`)
        ?.order('created_at', { ascending: false })
      return { data: data || [], error }
    } catch (error) {
      return { data: [], error }
    } 
  },
  async getCategoryById(categoryId) {
    try { 
      const { data, error } = await supabase
        ?.from('category')
        ?.select(`*,equipment(*,problem(*,service(*)))`)
        ?.eq('id', categoryId)
        ?.single()
      return { data: data || null, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async deleteCategory(categoryId) {
    try {
      const { data, error } = await supabase
        ?.from('category')
        ?.delete()
        ?.eq('id', categoryId)
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async updateCategory(categoryId, updates) {
    try {
      const { data, error } = await supabase
        ?.from('category')
        ?.update(updates)
        ?.eq('id', categoryId)
        ?.select()
        ?.single()
      return { data, error }
    } catch (error) {
      return { data: null, error }
    }
  },
  async addCategory(newCategory) {
    try { 
      const { data, error } = await supabase
        ?.from('category')
        ?.insert(newCategory)
        ?.select()
        ?.single()
      return { data, error }
    }
    catch (error) {   
      return { data: null, error }
    }
  },
}

export default {
  auth: authService,
  user: userService,
  category: categoryService,
  equipment: equipmentService,
  problem: problemService,
  service: serviceService,
  appointment: appointmentService,
  consumable: consumableService,
  emergencyPercentage: emergencyPercentageService,
  checklist: checklistService
}